export const VEHICLE_CATEGORIES = [
  { id: 'all', name: 'All Vehicles' },
  { id: 'sedan', name: 'Sedans' },
  { id: 'suv', name: 'SUVs' },
  { id: 'sports', name: 'Sports' },
  { id: 'luxury', name: 'Luxury' },
];

export const ADMIN_CATEGORIES = VEHICLE_CATEGORIES.filter((c) => c.id !== 'all');
